<template>
  <div class="text-center w-100 my-5">
    <div v-if="!noImage"><img src="@/assets/images/box-nothing.png" /></div>
    <div class="text-black-50 font-size-15 py-2">{{content}}</div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: "Đơn hàng của bạn chưa có sản phẩm nào",
    },
    noImage: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style></style>
